module.exports = __webpack_public_path__ + "img/shu.9749ec5d.png";